import { html } from 'lit';
const FirePanel =
  ({ width = '1em', height = '1em', style = '' }: { width?: string, height?: string, style?: string } = {}) =>
    html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${'user-select:none;flex-shrink:0;' + style}
  >
    <path fill='currentColor' d="M12 22c4.117 0 7.5-3.263 7.5-7.451 0-1.028-.052-2.13-.622-3.843-.263-.79-.429-1.262-.59-1.645-.187-.445-.897-.327-1.096.112-.515 1.13-1.329 1.67-1.587 1.868 0-.28-.833-3.373-2.096-5.224-.94-1.378-2.138-2.396-3.093-3.16-.329-.263-.838-.025-.879.395-.135 1.395-.506 3.01-.994 3.928-.619 1.162-.735 1.205-1.507 2.07s-1.127 1.133-1.772 2.182c-.646 1.05-.764 2.449-.764 3.477 0 4.188 3.383 7.29 7.5 7.29"/>
  </svg>
`;
export default FirePanel;
